export function redirectToEvoltzSso() {
  window.location.assign(`${process.env.REACT_APP_URI}/auth/saml/login?app=v3`);
}

/**
 * Lê o retorno do SSO. Com HashRouter, `search` é a query interna do fragmento
 * (o mesmo valor de props.location.search).
 * O payload vem da URL: é entrada não-confiável, então validamos só a forma.
 */
export function parseSsoCallback(search) {
  try {
    const params = new URLSearchParams(search);
    const token = params.get("token");
    const data = params.get("data");
    if (!token || !data) return null;

    // base64url -> base64, repondo o padding que o Buffer.toString("base64url") remove
    let b64 = data.replace(/-/g, "+").replace(/_/g, "/");
    while (b64.length % 4) b64 += "=";

    // atob devolve binário byte a byte; decodificar como UTF-8 para não
    // corromper acentos ("José" viraria "JosÃ©")
    const binario = window.atob(b64);
    const bytes = Uint8Array.from(binario, (c) => c.charCodeAt(0));
    const json = new TextDecoder("utf-8").decode(bytes);

    const payload = JSON.parse(json);
    const details = payload && payload.details;
    if (!details || !details.id || details.accessLevel === undefined) return null;

    return { token, details, userKey: payload.userKey };
  } catch (e) {
    return null;
  }
}

/**
 * Domínios do tenant Evoltz que autenticam via SSO. Espelha `SSO_EVOLTZ_DOMAINS`
 * do backend; o default no código garante que o handoff funcione mesmo sem a
 * variável configurada no build.
 */
const DOMINIOS_SSO_PADRAO = [
  "evoltz.com.br",
  "contratadas-evoltz.com.br",
  "resilionenergia.com.br",
];

export function dominiosSso() {
  const configurado = (process.env.REACT_APP_SSO_EVOLTZ_DOMAINS || "")
    .split(",")
    .map((d) => d.trim().toLowerCase())
    .filter(Boolean);
  return configurado.length ? configurado : DOMINIOS_SSO_PADRAO;
}

export function isSsoEvoltzEmail(email) {
  if (!email || typeof email !== "string" || !email.includes("@")) return false;
  const dominio = email.split("@")[1];
  return Boolean(dominio) && dominiosSso().includes(dominio.toLowerCase());
}

/**
 * Link do v3 para o v4 ("Módulos extras").
 *
 * Os dois apps vivem em hosts distintos e não compartilham sessão — o v3 guarda
 * o token em localStorage, o v4 em cookies host-only. Para quem entra por SSO,
 * passamos pelo próprio fluxo SAML: a sessão no Entra ID já está ativa, então o
 * IdP não pede credenciais e o v4 abre autenticado. Os demais continuam caindo
 * na tela de login do v4, como antes.
 */
export function linkParaV4(email) {
  if (isSsoEvoltzEmail(email)) {
    return `${process.env.REACT_APP_URI}/auth/saml/login?app=v4`;
  }
  return `${process.env.REACT_APP_V4_URI}/login`;
}
